"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { AvailableDestinations } from "./page/available-destinations";
import { Example } from "./page/example";
import { InputForm } from "./page/input-form";
import { cn } from "./shared/cn";
import { ExternalLink } from "./shared/external-link";
function H2(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <h2 className="mt-12 text-[1em] font-bold">{children}</h2>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
const remarkByDestination = {
  "": "no specified destination",
  h: "homepage",
  s: "source",
  r: "releases",
  x: "npmx",
  y: "yarn"
};

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- keys don't get correct typings automatically
const remarkByDestinationEntries = Object.entries(remarkByDestination) as Array<[DestinationKey, string]>;
type DestinationKey = keyof typeof remarkByDestination;
const exampleUrlByPackageAndDestination: Record<string, Record<DestinationKey, string>> = {
  prettier: {
    "": "https://www.npmjs.com/package/prettier",
    h: "https://prettier.io",
    s: "https://github.com/prettier/prettier",
    r: "https://github.com/prettier/prettier/releases",
    x: "https://npmx.dev/package/prettier",
    y: "https://yarnpkg.com/package/prettier"
  },
  typescript: {
    "": "https://www.npmjs.com/package/typescript",
    h: "https://www.typescriptlang.org",
    s: "https://github.com/microsoft/TypeScript",
    r: "https://github.com/microsoft/TypeScript/releases",
    x: "https://npmx.dev/package/typescript",
    y: "https://yarnpkg.com/package/typescript"
  },
  react: {
    "": "https://www.npmjs.com/package/react",
    h: "https://react.dev",
    s: "https://github.com/react/react/tree/main/packages/react",
    r: "https://github.com/react/react/releases",
    x: "https://npmx.dev/package/react",
    y: "https://yarnpkg.com/package/react"
  },
  tailwindcss: {
    "": "https://www.npmjs.com/package/tailwindcss",
    h: "https://tailwindcss.com",
    s: "https://github.com/tailwindlabs/tailwindcss/tree/main/packages/tailwindcss",
    r: "https://github.com/tailwindlabs/tailwindcss/releases",
    x: "https://npmx.dev/package/tailwindcss",
    y: "https://yarnpkg.com/package/tailwindcss"
  }
};
export default function Page() {
  const $ = _c(28);
  const [examplePackage, setExamplePackage] = React.useState(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = function handleExamplePackageClick(event) {
      setExamplePackage(event.currentTarget.textContent);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleExamplePackageClick = t0;
  const [inputText, setInputText] = React.useState("");
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function handleExampleClick(text) {
      setInputText(" ");
      setTimeout(() => {
        setInputText(text);
      }, 0);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleExampleClick = t1;
  let t2;
  if ($[2] !== examplePackage) {
    t2 = function handleSelectedDestinationChange(destination) {
      setInputText(currentInputText => {
        const currentPackage = currentInputText.trim().split(" ", 1)[0];
        return `${(currentPackage ?? "") || examplePackage} ${destination}`;
      });
    };
    $[2] = examplePackage;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleSelectedDestinationChange = t2;
  let t3;
  if ($[4] !== inputText) {
    t3 = <InputForm text={inputText} onTextChange={setInputText} />;
    $[4] = inputText;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <H2>Available destinations</H2>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== inputText) {
    t5 = inputText.trim().split(" ", 2);
    $[7] = inputText;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== handleSelectedDestinationChange || $[10] !== t5[1]) {
    t6 = <AvailableDestinations selectedDestination={t5[1]} onSelectedDestinationChange={handleSelectedDestinationChange} />;
    $[9] = handleSelectedDestinationChange;
    $[10] = t5[1];
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <H2>Examples</H2>;
    t8 = Object.keys(exampleUrlByPackageAndDestination);
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  let t10;
  let t9;
  if ($[14] !== examplePackage) {
    t9 = <div>{t8.map(currentExamplePackage => <div key={currentExamplePackage} className={cn("mr-2 inline-block cursor-default", currentExamplePackage !== examplePackage && "cursor-pointer border-b border-dotted border-foreground/40")} onClick={handleExamplePackageClick}>{currentExamplePackage}</div>)}</div>;
    t10 = remarkByDestinationEntries.map(t11 => {
      const [destination_0, remark] = t11;
      const destinationLookup = exampleUrlByPackageAndDestination[examplePackage];
      if (!destinationLookup) {
        return;
      }
      return <Example key={destination_0} to={`${examplePackage} ${destination_0}`.trim()} remark={remark} url={destinationLookup[destination_0]} onToClick={handleExampleClick} />;
    });
    $[14] = examplePackage;
    $[15] = t10;
    $[16] = t9;
  } else {
    t10 = $[15];
    t9 = $[16];
  }
  let t11;
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <H2>More!</H2>;
    t12 = <code>njt</code>;
    $[17] = t11;
    $[18] = t12;
  } else {
    t11 = $[17];
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <p>{t12} gives you an even bigger productivity boost when integrated into browser or terminal. See instructions in{" "}<ExternalLink href="https://github.com/kachkaev/njt/blob/main/README.md#getting-njt">GitHub repo’s README</ExternalLink>.</p>;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <ExternalLink href="https://en.kachkaev.ru">Alexander Kachkaev</ExternalLink>;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ExternalLink href="https://nextjs.org">Next.js</ExternalLink>;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <p>Crafted by{" "}{t14}{" "}using {t15}, hosted by <ExternalLink href="https://vercel.com">Vercel</ExternalLink> 💚</p>;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== t10 || $[24] !== t3 || $[25] !== t6 || $[26] !== t9) {
    t17 = <>{t3}{t4}{t6}{t7}{t9}{t10}{t11}{t13}{t16}</>;
    $[23] = t10;
    $[24] = t3;
    $[25] = t6;
    $[26] = t9;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  return t17;
}
function _temp() {
  return Object.keys(exampleUrlByPackageAndDestination)[0];
}